import { getCurrentInstance as Ue, inject as ar, ref as or, shallowRef as lr, computed as Fe, watch as ht, onMounted as ir, onUnmounted as cr, effectScope as ur, isRef as fr, defineComponent as Ft, h as Rn, Fragment as kn, createVNode as _r, Text as mr } from "vue";
/*!
  * shared v11.1.2
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const se = typeof window < "u";
let ee, Le;
if (process.env.NODE_ENV !== "production") {
  const e = se && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (ee = (t) => {
    e.mark(t);
  }, Le = (t, n, r) => {
    e.measure(t, n, r), e.clearMarks(n), e.clearMarks(r);
  });
}
const dr = /\{([0-9a-zA-Z]+)\}/g;
function qe(e, ...t) {
  return t.length === 1 && F(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(dr, (n, r) => t.hasOwnProperty(r) ? t[r] : "");
}
const le = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), Er = (e, t, n) => gr({ l: e, k: t, s: n }), gr = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), j = (e) => typeof e == "number" && isFinite(e), pr = (e) => Mt(e) === "[object Date]", Ce = (e) => Mt(e) === "[object RegExp]", Ze = (e) => k(e) && Object.keys(e).length === 0, J = Object.assign, Nr = Object.create, $ = (e = null) => Nr(e);
let Qt;
const Te = () => Qt || (Qt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : $());
function qt(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const Tr = Object.prototype.hasOwnProperty;
function re(e, t) {
  return Tr.call(e, t);
}
const K = Array.isArray, W = (e) => typeof e == "function", I = (e) => typeof e == "string", M = (e) => typeof e == "boolean", F = (e) => e !== null && typeof e == "object", Lr = (e) => F(e) && W(e.then) && W(e.catch), Fn = Object.prototype.toString, Mt = (e) => Fn.call(e), k = (e) => Mt(e) === "[object Object]", hr = (e) => e == null ? "" : K(e) || k(e) && e.toString === Fn ? JSON.stringify(e, null, 2) : String(e);
function Ut(e, t = "") {
  return e.reduce((n, r, s) => s === 0 ? n + r : n + t + r, "");
}
const Zt = 2;
function Or(e, t = 0, n = e.length) {
  const r = e.split(/\r?\n/);
  let s = 0;
  const a = [];
  for (let o = 0; o < r.length; o++)
    if (s += r[o].length + 1, s >= t) {
      for (let c = o - Zt; c <= o + Zt || n > s; c++) {
        if (c < 0 || c >= r.length)
          continue;
        const u = c + 1;
        a.push(`${u}${" ".repeat(3 - String(u).length)}|  ${r[c]}`);
        const E = r[c].length;
        if (c === o) {
          const O = t - (s - E) + 1, L = Math.max(1, n > s ? E - O : n - t);
          a.push("   |  " + " ".repeat(O) + "^".repeat(L));
        } else if (c > o) {
          if (n > s) {
            const O = Math.max(Math.min(n - s, E), 1);
            a.push("   |  " + "^".repeat(O));
          }
          s += E + 1;
        }
      }
      break;
    }
  return a.join(`
`);
}
function me(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const zt = {};
function wt(e) {
  zt[e] || (zt[e] = !0, me(e));
}
function Vt() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, r) {
      const s = e.get(n);
      s && s.push(r) || e.set(n, [r]);
    },
    off(n, r) {
      const s = e.get(n);
      s && s.splice(s.indexOf(r) >>> 0, 1);
    },
    emit(n, r) {
      (e.get(n) || []).slice().map((s) => s(r)), (e.get("*") || []).slice().map((s) => s(n, r));
    }
  };
}
const je = (e) => !F(e) || K(e);
function Je(e, t) {
  if (je(e) || je(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: r, des: s } = n.pop();
    Object.keys(r).forEach((a) => {
      a !== "__proto__" && (F(r[a]) && !F(s[a]) && (s[a] = Array.isArray(r[a]) ? [] : $()), je(s[a]) || je(r[a]) ? s[a] = r[a] : n.push({ src: r[a], des: s[a] }));
    });
  }
}
/*!
  * message-compiler v11.1.2
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function br(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Ot(e, t, n) {
  return { start: e, end: t };
}
const y = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, Ir = 17, vr = {
  // tokenizer error messages
  [y.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [y.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [y.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [y.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [y.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [y.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [y.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [y.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [y.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [y.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [y.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [y.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [y.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [y.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [y.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [y.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function De(e, t, n = {}) {
  const { domain: r, messages: s, args: a } = n, o = process.env.NODE_ENV !== "production" ? qe((s || vr)[e] || "", ...a || []) : e, c = new SyntaxError(String(o));
  return c.code = e, t && (c.location = t), c.domain = r, c;
}
function Ar(e) {
  throw e;
}
const Cr = /<\/?[\w\s="/.':;#-\/]+>/, Sr = (e) => Cr.test(e), ce = " ", Dr = "\r", q = `
`, Pr = "\u2028", yr = "\u2029";
function Rr(e) {
  const t = e;
  let n = 0, r = 1, s = 1, a = 0;
  const o = (g) => t[g] === Dr && t[g + 1] === q, c = (g) => t[g] === q, u = (g) => t[g] === yr, E = (g) => t[g] === Pr, O = (g) => o(g) || c(g) || u(g) || E(g), L = () => n, N = () => r, C = () => s, P = () => a, A = (g) => o(g) || u(g) || E(g) ? q : t[g], S = () => A(n), f = () => A(n + a);
  function m() {
    return a = 0, O(n) && (r++, s = 0), o(n) && n++, n++, s++, t[n];
  }
  function h() {
    return o(n + a) && a++, a++, t[n + a];
  }
  function d() {
    n = 0, r = 1, s = 1, a = 0;
  }
  function b(g = 0) {
    a = g;
  }
  function v() {
    const g = n + a;
    for (; g !== n; )
      m();
    a = 0;
  }
  return {
    index: L,
    line: N,
    column: C,
    peekOffset: P,
    charAt: A,
    currentChar: S,
    currentPeek: f,
    next: m,
    peek: h,
    reset: d,
    resetPeek: b,
    skipToPeek: v
  };
}
const fe = void 0, kr = ".", en = "'", Fr = "tokenizer";
function Mr(e, t = {}) {
  const n = t.location !== !1, r = Rr(e), s = () => r.index(), a = () => br(r.line(), r.column(), r.index()), o = a(), c = s(), u = {
    currentType: 13,
    offset: c,
    startLoc: o,
    endLoc: o,
    lastType: 13,
    lastOffset: c,
    lastStartLoc: o,
    lastEndLoc: o,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, E = () => u, { onError: O } = t;
  function L(l, i, p, ...D) {
    const x = E();
    if (i.column += p, i.offset += p, O) {
      const Y = n ? Ot(x.startLoc, i) : null, U = De(l, Y, {
        domain: Fr,
        args: D
      });
      O(U);
    }
  }
  function N(l, i, p) {
    l.endLoc = a(), l.currentType = i;
    const D = { type: i };
    return n && (D.loc = Ot(l.startLoc, l.endLoc)), p != null && (D.value = p), D;
  }
  const C = (l) => N(
    l,
    13
    /* TokenTypes.EOF */
  );
  function P(l, i) {
    return l.currentChar() === i ? (l.next(), i) : (L(y.EXPECTED_TOKEN, a(), 0, i), "");
  }
  function A(l) {
    let i = "";
    for (; l.currentPeek() === ce || l.currentPeek() === q; )
      i += l.currentPeek(), l.peek();
    return i;
  }
  function S(l) {
    const i = A(l);
    return l.skipToPeek(), i;
  }
  function f(l) {
    if (l === fe)
      return !1;
    const i = l.charCodeAt(0);
    return i >= 97 && i <= 122 || // a-z
    i >= 65 && i <= 90 || // A-Z
    i === 95;
  }
  function m(l) {
    if (l === fe)
      return !1;
    const i = l.charCodeAt(0);
    return i >= 48 && i <= 57;
  }
  function h(l, i) {
    const { currentType: p } = i;
    if (p !== 2)
      return !1;
    A(l);
    const D = f(l.currentPeek());
    return l.resetPeek(), D;
  }
  function d(l, i) {
    const { currentType: p } = i;
    if (p !== 2)
      return !1;
    A(l);
    const D = l.currentPeek() === "-" ? l.peek() : l.currentPeek(), x = m(D);
    return l.resetPeek(), x;
  }
  function b(l, i) {
    const { currentType: p } = i;
    if (p !== 2)
      return !1;
    A(l);
    const D = l.currentPeek() === en;
    return l.resetPeek(), D;
  }
  function v(l, i) {
    const { currentType: p } = i;
    if (p !== 7)
      return !1;
    A(l);
    const D = l.currentPeek() === ".";
    return l.resetPeek(), D;
  }
  function g(l, i) {
    const { currentType: p } = i;
    if (p !== 8)
      return !1;
    A(l);
    const D = f(l.currentPeek());
    return l.resetPeek(), D;
  }
  function R(l, i) {
    const { currentType: p } = i;
    if (!(p === 7 || p === 11))
      return !1;
    A(l);
    const D = l.currentPeek() === ":";
    return l.resetPeek(), D;
  }
  function w(l, i) {
    const { currentType: p } = i;
    if (p !== 9)
      return !1;
    const D = () => {
      const Y = l.currentPeek();
      return Y === "{" ? f(l.peek()) : Y === "@" || Y === "|" || Y === ":" || Y === "." || Y === ce || !Y ? !1 : Y === q ? (l.peek(), D()) : ne(l, !1);
    }, x = D();
    return l.resetPeek(), x;
  }
  function B(l) {
    A(l);
    const i = l.currentPeek() === "|";
    return l.resetPeek(), i;
  }
  function ne(l, i = !0) {
    const p = (x = !1, Y = "") => {
      const U = l.currentPeek();
      return U === "{" || U === "@" || !U ? x : U === "|" ? !(Y === ce || Y === q) : U === ce ? (l.peek(), p(!0, ce)) : U === q ? (l.peek(), p(!0, q)) : !0;
    }, D = p();
    return i && l.resetPeek(), D;
  }
  function X(l, i) {
    const p = l.currentChar();
    return p === fe ? fe : i(p) ? (l.next(), p) : null;
  }
  function be(l) {
    const i = l.charCodeAt(0);
    return i >= 97 && i <= 122 || // a-z
    i >= 65 && i <= 90 || // A-Z
    i >= 48 && i <= 57 || // 0-9
    i === 95 || // _
    i === 36;
  }
  function tt(l) {
    return X(l, be);
  }
  function nt(l) {
    const i = l.charCodeAt(0);
    return i >= 97 && i <= 122 || // a-z
    i >= 65 && i <= 90 || // A-Z
    i >= 48 && i <= 57 || // 0-9
    i === 95 || // _
    i === 36 || // $
    i === 45;
  }
  function rt(l) {
    return X(l, nt);
  }
  function st(l) {
    const i = l.charCodeAt(0);
    return i >= 48 && i <= 57;
  }
  function at(l) {
    return X(l, st);
  }
  function ot(l) {
    const i = l.charCodeAt(0);
    return i >= 48 && i <= 57 || // 0-9
    i >= 65 && i <= 70 || // A-F
    i >= 97 && i <= 102;
  }
  function ie(l) {
    return X(l, ot);
  }
  function Pe(l) {
    let i = "", p = "";
    for (; i = at(l); )
      p += i;
    return p;
  }
  function lt(l) {
    let i = "";
    for (; ; ) {
      const p = l.currentChar();
      if (p === "{" || p === "}" || p === "@" || p === "|" || !p)
        break;
      if (p === ce || p === q)
        if (ne(l))
          i += p, l.next();
        else {
          if (B(l))
            break;
          i += p, l.next();
        }
      else
        i += p, l.next();
    }
    return i;
  }
  function it(l) {
    S(l);
    let i = "", p = "";
    for (; i = rt(l); )
      p += i;
    return l.currentChar() === fe && L(y.UNTERMINATED_CLOSING_BRACE, a(), 0), p;
  }
  function ct(l) {
    S(l);
    let i = "";
    return l.currentChar() === "-" ? (l.next(), i += `-${Pe(l)}`) : i += Pe(l), l.currentChar() === fe && L(y.UNTERMINATED_CLOSING_BRACE, a(), 0), i;
  }
  function ut(l) {
    return l !== en && l !== q;
  }
  function Xt(l) {
    S(l), P(l, "'");
    let i = "", p = "";
    for (; i = X(l, ut); )
      i === "\\" ? p += ft(l) : p += i;
    const D = l.currentChar();
    return D === q || D === fe ? (L(y.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, a(), 0), D === q && (l.next(), P(l, "'")), p) : (P(l, "'"), p);
  }
  function ft(l) {
    const i = l.currentChar();
    switch (i) {
      case "\\":
      case "'":
        return l.next(), `\\${i}`;
      case "u":
        return He(l, i, 4);
      case "U":
        return He(l, i, 6);
      default:
        return L(y.UNKNOWN_ESCAPE_SEQUENCE, a(), 0, i), "";
    }
  }
  function He(l, i, p) {
    P(l, i);
    let D = "";
    for (let x = 0; x < p; x++) {
      const Y = ie(l);
      if (!Y) {
        L(y.INVALID_UNICODE_ESCAPE_SEQUENCE, a(), 0, `\\${i}${D}${l.currentChar()}`);
        break;
      }
      D += Y;
    }
    return `\\${i}${D}`;
  }
  function _t(l) {
    return l !== "{" && l !== "}" && l !== ce && l !== q;
  }
  function mt(l) {
    S(l);
    let i = "", p = "";
    for (; i = X(l, _t); )
      p += i;
    return p;
  }
  function dt(l) {
    let i = "", p = "";
    for (; i = tt(l); )
      p += i;
    return p;
  }
  function Et(l) {
    const i = (p) => {
      const D = l.currentChar();
      return D === "{" || D === "@" || D === "|" || D === "(" || D === ")" || !D || D === ce ? p : (p += D, l.next(), i(p));
    };
    return i("");
  }
  function ye(l) {
    S(l);
    const i = P(
      l,
      "|"
      /* TokenChars.Pipe */
    );
    return S(l), i;
  }
  function Re(l, i) {
    let p = null;
    switch (l.currentChar()) {
      case "{":
        return i.braceNest >= 1 && L(y.NOT_ALLOW_NEST_PLACEHOLDER, a(), 0), l.next(), p = N(
          i,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), S(l), i.braceNest++, p;
      case "}":
        return i.braceNest > 0 && i.currentType === 2 && L(y.EMPTY_PLACEHOLDER, a(), 0), l.next(), p = N(
          i,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), i.braceNest--, i.braceNest > 0 && S(l), i.inLinked && i.braceNest === 0 && (i.inLinked = !1), p;
      case "@":
        return i.braceNest > 0 && L(y.UNTERMINATED_CLOSING_BRACE, a(), 0), p = ge(l, i) || C(i), i.braceNest = 0, p;
      default: {
        let x = !0, Y = !0, U = !0;
        if (B(l))
          return i.braceNest > 0 && L(y.UNTERMINATED_CLOSING_BRACE, a(), 0), p = N(i, 1, ye(l)), i.braceNest = 0, i.inLinked = !1, p;
        if (i.braceNest > 0 && (i.currentType === 4 || i.currentType === 5 || i.currentType === 6))
          return L(y.UNTERMINATED_CLOSING_BRACE, a(), 0), i.braceNest = 0, ke(l, i);
        if (x = h(l, i))
          return p = N(i, 4, it(l)), S(l), p;
        if (Y = d(l, i))
          return p = N(i, 5, ct(l)), S(l), p;
        if (U = b(l, i))
          return p = N(i, 6, Xt(l)), S(l), p;
        if (!x && !Y && !U)
          return p = N(i, 12, mt(l)), L(y.INVALID_TOKEN_IN_PLACEHOLDER, a(), 0, p.value), S(l), p;
        break;
      }
    }
    return p;
  }
  function ge(l, i) {
    const { currentType: p } = i;
    let D = null;
    const x = l.currentChar();
    switch ((p === 7 || p === 8 || p === 11 || p === 9) && (x === q || x === ce) && L(y.INVALID_LINKED_FORMAT, a(), 0), x) {
      case "@":
        return l.next(), D = N(
          i,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), i.inLinked = !0, D;
      case ".":
        return S(l), l.next(), N(
          i,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return S(l), l.next(), N(
          i,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return B(l) ? (D = N(i, 1, ye(l)), i.braceNest = 0, i.inLinked = !1, D) : v(l, i) || R(l, i) ? (S(l), ge(l, i)) : g(l, i) ? (S(l), N(i, 11, dt(l))) : w(l, i) ? (S(l), x === "{" ? Re(l, i) || D : N(i, 10, Et(l))) : (p === 7 && L(y.INVALID_LINKED_FORMAT, a(), 0), i.braceNest = 0, i.inLinked = !1, ke(l, i));
    }
  }
  function ke(l, i) {
    let p = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (i.braceNest > 0)
      return Re(l, i) || C(i);
    if (i.inLinked)
      return ge(l, i) || C(i);
    switch (l.currentChar()) {
      case "{":
        return Re(l, i) || C(i);
      case "}":
        return L(y.UNBALANCED_CLOSING_BRACE, a(), 0), l.next(), N(
          i,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return ge(l, i) || C(i);
      default: {
        if (B(l))
          return p = N(i, 1, ye(l)), i.braceNest = 0, i.inLinked = !1, p;
        if (ne(l))
          return N(i, 0, lt(l));
        break;
      }
    }
    return p;
  }
  function gt() {
    const { currentType: l, offset: i, startLoc: p, endLoc: D } = u;
    return u.lastType = l, u.lastOffset = i, u.lastStartLoc = p, u.lastEndLoc = D, u.offset = s(), u.startLoc = a(), r.currentChar() === fe ? N(
      u,
      13
      /* TokenTypes.EOF */
    ) : ke(r, u);
  }
  return {
    nextToken: gt,
    currentOffset: s,
    currentPosition: a,
    context: E
  };
}
const Ur = "parser", wr = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function Vr(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    // eslint-disable-next-line no-useless-escape
    case "\\'":
      return "'";
    default: {
      const r = parseInt(t || n, 16);
      return r <= 55295 || r >= 57344 ? String.fromCodePoint(r) : "�";
    }
  }
}
function $r(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function r(f, m, h, d, ...b) {
    const v = f.currentPosition();
    if (v.offset += d, v.column += d, n) {
      const g = t ? Ot(h, v) : null, R = De(m, g, {
        domain: Ur,
        args: b
      });
      n(R);
    }
  }
  function s(f, m, h) {
    const d = { type: f };
    return t && (d.start = m, d.end = m, d.loc = { start: h, end: h }), d;
  }
  function a(f, m, h, d) {
    t && (f.end = m, f.loc && (f.loc.end = h));
  }
  function o(f, m) {
    const h = f.context(), d = s(3, h.offset, h.startLoc);
    return d.value = m, a(d, f.currentOffset(), f.currentPosition()), d;
  }
  function c(f, m) {
    const h = f.context(), { lastOffset: d, lastStartLoc: b } = h, v = s(5, d, b);
    return v.index = parseInt(m, 10), f.nextToken(), a(v, f.currentOffset(), f.currentPosition()), v;
  }
  function u(f, m) {
    const h = f.context(), { lastOffset: d, lastStartLoc: b } = h, v = s(4, d, b);
    return v.key = m, f.nextToken(), a(v, f.currentOffset(), f.currentPosition()), v;
  }
  function E(f, m) {
    const h = f.context(), { lastOffset: d, lastStartLoc: b } = h, v = s(9, d, b);
    return v.value = m.replace(wr, Vr), f.nextToken(), a(v, f.currentOffset(), f.currentPosition()), v;
  }
  function O(f) {
    const m = f.nextToken(), h = f.context(), { lastOffset: d, lastStartLoc: b } = h, v = s(8, d, b);
    return m.type !== 11 ? (r(f, y.UNEXPECTED_EMPTY_LINKED_MODIFIER, h.lastStartLoc, 0), v.value = "", a(v, d, b), {
      nextConsumeToken: m,
      node: v
    }) : (m.value == null && r(f, y.UNEXPECTED_LEXICAL_ANALYSIS, h.lastStartLoc, 0, ae(m)), v.value = m.value || "", a(v, f.currentOffset(), f.currentPosition()), {
      node: v
    });
  }
  function L(f, m) {
    const h = f.context(), d = s(7, h.offset, h.startLoc);
    return d.value = m, a(d, f.currentOffset(), f.currentPosition()), d;
  }
  function N(f) {
    const m = f.context(), h = s(6, m.offset, m.startLoc);
    let d = f.nextToken();
    if (d.type === 8) {
      const b = O(f);
      h.modifier = b.node, d = b.nextConsumeToken || f.nextToken();
    }
    switch (d.type !== 9 && r(f, y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ae(d)), d = f.nextToken(), d.type === 2 && (d = f.nextToken()), d.type) {
      case 10:
        d.value == null && r(f, y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ae(d)), h.key = L(f, d.value || "");
        break;
      case 4:
        d.value == null && r(f, y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ae(d)), h.key = u(f, d.value || "");
        break;
      case 5:
        d.value == null && r(f, y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ae(d)), h.key = c(f, d.value || "");
        break;
      case 6:
        d.value == null && r(f, y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ae(d)), h.key = E(f, d.value || "");
        break;
      default: {
        r(f, y.UNEXPECTED_EMPTY_LINKED_KEY, m.lastStartLoc, 0);
        const b = f.context(), v = s(7, b.offset, b.startLoc);
        return v.value = "", a(v, b.offset, b.startLoc), h.key = v, a(h, b.offset, b.startLoc), {
          nextConsumeToken: d,
          node: h
        };
      }
    }
    return a(h, f.currentOffset(), f.currentPosition()), {
      node: h
    };
  }
  function C(f) {
    const m = f.context(), h = m.currentType === 1 ? f.currentOffset() : m.offset, d = m.currentType === 1 ? m.endLoc : m.startLoc, b = s(2, h, d);
    b.items = [];
    let v = null;
    do {
      const w = v || f.nextToken();
      switch (v = null, w.type) {
        case 0:
          w.value == null && r(f, y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ae(w)), b.items.push(o(f, w.value || ""));
          break;
        case 5:
          w.value == null && r(f, y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ae(w)), b.items.push(c(f, w.value || ""));
          break;
        case 4:
          w.value == null && r(f, y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ae(w)), b.items.push(u(f, w.value || ""));
          break;
        case 6:
          w.value == null && r(f, y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ae(w)), b.items.push(E(f, w.value || ""));
          break;
        case 7: {
          const B = N(f);
          b.items.push(B.node), v = B.nextConsumeToken || null;
          break;
        }
      }
    } while (m.currentType !== 13 && m.currentType !== 1);
    const g = m.currentType === 1 ? m.lastOffset : f.currentOffset(), R = m.currentType === 1 ? m.lastEndLoc : f.currentPosition();
    return a(b, g, R), b;
  }
  function P(f, m, h, d) {
    const b = f.context();
    let v = d.items.length === 0;
    const g = s(1, m, h);
    g.cases = [], g.cases.push(d);
    do {
      const R = C(f);
      v || (v = R.items.length === 0), g.cases.push(R);
    } while (b.currentType !== 13);
    return v && r(f, y.MUST_HAVE_MESSAGES_IN_PLURAL, h, 0), a(g, f.currentOffset(), f.currentPosition()), g;
  }
  function A(f) {
    const m = f.context(), { offset: h, startLoc: d } = m, b = C(f);
    return m.currentType === 13 ? b : P(f, h, d, b);
  }
  function S(f) {
    const m = Mr(f, J({}, e)), h = m.context(), d = s(0, h.offset, h.startLoc);
    return t && d.loc && (d.loc.source = f), d.body = A(m), e.onCacheKey && (d.cacheKey = e.onCacheKey(f)), h.currentType !== 13 && r(m, y.UNEXPECTED_LEXICAL_ANALYSIS, h.lastStartLoc, 0, f[h.offset] || ""), a(d, m.currentOffset(), m.currentPosition()), d;
  }
  return { parse: S };
}
function ae(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Wr(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (a) => (n.helpers.add(a), a) };
}
function tn(e, t) {
  for (let n = 0; n < e.length; n++)
    $t(e[n], t);
}
function $t(e, t) {
  switch (e.type) {
    case 1:
      tn(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      tn(e.items, t);
      break;
    case 6: {
      $t(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function Gr(e, t = {}) {
  const n = Wr(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && $t(e.body, n);
  const r = n.context();
  e.helpers = Array.from(r.helpers);
}
function xr(e) {
  const t = e.body;
  return t.type === 2 ? nn(t) : t.cases.forEach((n) => nn(n)), e;
}
function nn(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const r = e.items[n];
      if (!(r.type === 3 || r.type === 9) || r.value == null)
        break;
      t.push(r.value);
    }
    if (t.length === e.items.length) {
      e.static = Ut(t);
      for (let n = 0; n < e.items.length; n++) {
        const r = e.items[n];
        (r.type === 3 || r.type === 9) && delete r.value;
      }
    }
  }
}
const Yr = "minifier";
function Ae(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      Ae(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let r = 0; r < n.length; r++)
        Ae(n[r]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let r = 0; r < n.length; r++)
        Ae(n[r]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      Ae(t.key), t.k = t.key, delete t.key, t.modifier && (Ae(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw De(y.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: Yr,
          args: [e.type]
        });
  }
  delete e.type;
}
const Hr = "parser";
function Kr(e, t) {
  const { filename: n, breakLineCode: r, needIndent: s } = t, a = t.location !== !1, o = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: r,
    needIndent: s,
    indentLevel: 0
  };
  a && e.loc && (o.source = e.loc.source);
  const c = () => o;
  function u(A, S) {
    o.code += A;
  }
  function E(A, S = !0) {
    const f = S ? r : "";
    u(s ? f + "  ".repeat(A) : f);
  }
  function O(A = !0) {
    const S = ++o.indentLevel;
    A && E(S);
  }
  function L(A = !0) {
    const S = --o.indentLevel;
    A && E(S);
  }
  function N() {
    E(o.indentLevel);
  }
  return {
    context: c,
    push: u,
    indent: O,
    deindent: L,
    newline: N,
    helper: (A) => `_${A}`,
    needIndent: () => o.needIndent
  };
}
function jr(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Se(e, t.key), t.modifier ? (e.push(", "), Se(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Br(e, t) {
  const { helper: n, needIndent: r } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(r());
  const s = t.items.length;
  for (let a = 0; a < s && (Se(e, t.items[a]), a !== s - 1); a++)
    e.push(", ");
  e.deindent(r()), e.push("])");
}
function Xr(e, t) {
  const { helper: n, needIndent: r } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(r());
    const s = t.cases.length;
    for (let a = 0; a < s && (Se(e, t.cases[a]), a !== s - 1); a++)
      e.push(", ");
    e.deindent(r()), e.push("])");
  }
}
function Jr(e, t) {
  t.body ? Se(e, t.body) : e.push("null");
}
function Se(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      Jr(e, t);
      break;
    case 1:
      Xr(e, t);
      break;
    case 2:
      Br(e, t);
      break;
    case 6:
      jr(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw De(y.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: Hr,
          args: [t.type]
        });
  }
}
const Qr = (e, t = {}) => {
  const n = I(t.mode) ? t.mode : "normal", r = I(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const s = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, a = t.needIndent ? t.needIndent : n !== "arrow", o = e.helpers || [], c = Kr(e, {
    filename: r,
    breakLineCode: s,
    needIndent: a
  });
  c.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), c.indent(a), o.length > 0 && (c.push(`const { ${Ut(o.map((O) => `${O}: _${O}`), ", ")} } = ctx`), c.newline()), c.push("return "), Se(c, e), c.deindent(a), c.push("}"), delete e.helpers;
  const { code: u, map: E } = c.context();
  return {
    ast: e,
    code: u,
    map: E ? E.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function qr(e, t = {}) {
  const n = J({}, t), r = !!n.jit, s = !!n.minify, a = n.optimize == null ? !0 : n.optimize, c = $r(n).parse(e);
  return r ? (a && xr(c), s && Ae(c), { ast: c, code: "" }) : (Gr(c, n), Qr(c, n));
}
/*!
  * core-base v11.1.2
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Zr() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Te().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Te().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function pt(e) {
  return (n) => zr(n, e);
}
function zr(e, t) {
  const n = ts(t);
  if (n == null)
    throw we(
      0
      /* NodeTypes.Resource */
    );
  if (Wt(n) === 1) {
    const a = rs(n);
    return e.plural(a.reduce((o, c) => [
      ...o,
      rn(e, c)
    ], []));
  } else
    return rn(e, n);
}
const es = ["b", "body"];
function ts(e) {
  return de(e, es);
}
const ns = ["c", "cases"];
function rs(e) {
  return de(e, ns, []);
}
function rn(e, t) {
  const n = as(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const r = ls(t).reduce((s, a) => [...s, bt(e, a)], []);
    return e.normalize(r);
  }
}
const ss = ["s", "static"];
function as(e) {
  return de(e, ss);
}
const os = ["i", "items"];
function ls(e) {
  return de(e, os, []);
}
function bt(e, t) {
  const n = Wt(t);
  switch (n) {
    case 3:
      return Be(t, n);
    case 9:
      return Be(t, n);
    case 4: {
      const r = t;
      if (re(r, "k") && r.k)
        return e.interpolate(e.named(r.k));
      if (re(r, "key") && r.key)
        return e.interpolate(e.named(r.key));
      throw we(n);
    }
    case 5: {
      const r = t;
      if (re(r, "i") && j(r.i))
        return e.interpolate(e.list(r.i));
      if (re(r, "index") && j(r.index))
        return e.interpolate(e.list(r.index));
      throw we(n);
    }
    case 6: {
      const r = t, s = fs(r), a = ms(r);
      return e.linked(bt(e, a), s ? bt(e, s) : void 0, e.type);
    }
    case 7:
      return Be(t, n);
    case 8:
      return Be(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const is = ["t", "type"];
function Wt(e) {
  return de(e, is);
}
const cs = ["v", "value"];
function Be(e, t) {
  const n = de(e, cs);
  if (n)
    return n;
  throw we(t);
}
const us = ["m", "modifier"];
function fs(e) {
  return de(e, us);
}
const _s = ["k", "key"];
function ms(e) {
  const t = de(e, _s);
  if (t)
    return t;
  throw we(
    6
    /* NodeTypes.Linked */
  );
}
function de(e, t, n) {
  for (let r = 0; r < t.length; r++) {
    const s = t[r];
    if (re(e, s) && e[s] != null)
      return e[s];
  }
  return n;
}
function we(e) {
  return new Error(`unhandled node type: ${e}`);
}
const ds = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Es(e, t) {
  t && Sr(e) && me(qe(ds, { source: e }));
}
const gs = (e) => e;
let Xe = $();
function _e(e) {
  return F(e) && Wt(e) === 0 && (re(e, "b") || re(e, "body"));
}
function ps(e, t = {}) {
  let n = !1;
  const r = t.onError || Ar;
  return t.onError = (s) => {
    n = !0, r(s);
  }, { ...qr(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function Ns(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && I(e)) {
    const n = M(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Es(e, n);
    const s = (t.onCacheKey || gs)(e), a = Xe[s];
    if (a)
      return a;
    const { ast: o, detectError: c } = ps(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), u = pt(o);
    return c ? u : Xe[s] = u;
  } else {
    if (process.env.NODE_ENV !== "production" && !_e(e))
      return me(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const r = Xe[n];
      return r || (Xe[n] = pt(e));
    } else
      return pt(e);
  }
}
let Ve = null;
function Ts(e) {
  Ve = e;
}
function Ls(e, t, n) {
  Ve && Ve.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const hs = /* @__PURE__ */ Os("function:translate");
function Os(e) {
  return (t) => Ve && Ve.emit(e, t);
}
const Q = {
  INVALID_ARGUMENT: Ir,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, bs = 24;
function ue(e) {
  return De(e, null, process.env.NODE_ENV !== "production" ? { messages: Is } : void 0);
}
const Is = {
  [Q.INVALID_ARGUMENT]: "Invalid arguments",
  [Q.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Q.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Q.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Q.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Q.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Q.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Gt(e, t) {
  return t.locale != null ? sn(t.locale) : sn(e.locale);
}
let Nt;
function sn(e) {
  if (I(e))
    return e;
  if (W(e)) {
    if (e.resolvedOnce && Nt != null)
      return Nt;
    if (e.constructor.name === "Function") {
      const t = e();
      if (Lr(t))
        throw ue(Q.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Nt = t;
    } else
      throw ue(Q.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw ue(Q.NOT_SUPPORT_LOCALE_TYPE);
}
function vs(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...K(t) ? t : F(t) ? Object.keys(t) : I(t) ? [t] : [n]
  ])];
}
function Mn(e, t, n) {
  const r = I(n) ? n : $e, s = e;
  s.__localeChainCache || (s.__localeChainCache = /* @__PURE__ */ new Map());
  let a = s.__localeChainCache.get(r);
  if (!a) {
    a = [];
    let o = [n];
    for (; K(o); )
      o = an(a, o, t);
    const c = K(t) || !k(t) ? t : t.default ? t.default : null;
    o = I(c) ? [c] : c, K(o) && an(a, o, !1), s.__localeChainCache.set(r, a);
  }
  return a;
}
function an(e, t, n) {
  let r = !0;
  for (let s = 0; s < t.length && M(r); s++) {
    const a = t[s];
    I(a) && (r = As(e, t[s], n));
  }
  return r;
}
function As(e, t, n) {
  let r;
  const s = t.split("-");
  do {
    const a = s.join("-");
    r = Cs(e, a, n), s.splice(-1, 1);
  } while (s.length && r === !0);
  return r;
}
function Cs(e, t, n) {
  let r = !1;
  if (!e.includes(t) && (r = !0, t)) {
    r = t[t.length - 1] !== "!";
    const s = t.replace(/!/g, "");
    e.push(s), (K(n) || k(n)) && n[s] && (r = n[s]);
  }
  return r;
}
const Ee = [];
Ee[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Ee[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Ee[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
Ee[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
Ee[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
Ee[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
Ee[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Ss = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Ds(e) {
  return Ss.test(e);
}
function Ps(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function ys(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return e;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
function Rs(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : Ds(t) ? Ps(t) : "*" + t;
}
function ks(e) {
  const t = [];
  let n = -1, r = 0, s = 0, a, o, c, u, E, O, L;
  const N = [];
  N[
    0
    /* Actions.APPEND */
  ] = () => {
    o === void 0 ? o = c : o += c;
  }, N[
    1
    /* Actions.PUSH */
  ] = () => {
    o !== void 0 && (t.push(o), o = void 0);
  }, N[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    N[
      0
      /* Actions.APPEND */
    ](), s++;
  }, N[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (s > 0)
      s--, r = 4, N[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (s = 0, o === void 0 || (o = Rs(o), o === !1))
        return !1;
      N[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function C() {
    const P = e[n + 1];
    if (r === 5 && P === "'" || r === 6 && P === '"')
      return n++, c = "\\" + P, N[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; r !== null; )
    if (n++, a = e[n], !(a === "\\" && C())) {
      if (u = ys(a), L = Ee[r], E = L[u] || L.l || 8, E === 8 || (r = E[0], E[1] !== void 0 && (O = N[E[1]], O && (c = a, O() === !1))))
        return;
      if (r === 7)
        return t;
    }
}
const on = /* @__PURE__ */ new Map();
function Fs(e, t) {
  return F(e) ? e[t] : null;
}
function Ms(e, t) {
  if (!F(e))
    return null;
  let n = on.get(t);
  if (n || (n = ks(t), n && on.set(t, n)), !n)
    return null;
  const r = n.length;
  let s = e, a = 0;
  for (; a < r; ) {
    const o = s[n[a]];
    if (o === void 0 || W(s))
      return null;
    s = o, a++;
  }
  return s;
}
const Z = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, Us = 8, ws = {
  [Z.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Z.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Z.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Z.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Z.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Z.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Z.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function he(e, ...t) {
  return qe(ws[e], ...t);
}
const Vs = "11.1.2", ze = -1, $e = "en-US", Qe = "", ln = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function $s() {
  return {
    upper: (e, t) => t === "text" && I(e) ? e.toUpperCase() : t === "vnode" && F(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && I(e) ? e.toLowerCase() : t === "vnode" && F(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && I(e) ? ln(e) : t === "vnode" && F(e) && "__v_isVNode" in e ? ln(e.children) : e
  };
}
let Un;
function Ws(e) {
  Un = e;
}
let wn;
function Gs(e) {
  wn = e;
}
let Vn;
function xs(e) {
  Vn = e;
}
let $n = null;
const Ys = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  $n = e;
}, Hs = /* @__NO_SIDE_EFFECTS__ */ () => $n;
let Wn = null;
const cn = (e) => {
  Wn = e;
}, Ks = () => Wn;
let un = 0;
function js(e = {}) {
  const t = W(e.onWarn) ? e.onWarn : me, n = I(e.version) ? e.version : Vs, r = I(e.locale) || W(e.locale) ? e.locale : $e, s = W(r) ? $e : r, a = K(e.fallbackLocale) || k(e.fallbackLocale) || I(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : s, o = k(e.messages) ? e.messages : Tt(s), c = k(e.datetimeFormats) ? e.datetimeFormats : Tt(s), u = k(e.numberFormats) ? e.numberFormats : Tt(s), E = J($(), e.modifiers, $s()), O = e.pluralRules || $(), L = W(e.missing) ? e.missing : null, N = M(e.missingWarn) || Ce(e.missingWarn) ? e.missingWarn : !0, C = M(e.fallbackWarn) || Ce(e.fallbackWarn) ? e.fallbackWarn : !0, P = !!e.fallbackFormat, A = !!e.unresolving, S = W(e.postTranslation) ? e.postTranslation : null, f = k(e.processor) ? e.processor : null, m = M(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, h = !!e.escapeParameter, d = W(e.messageCompiler) ? e.messageCompiler : Un;
  process.env.NODE_ENV !== "production" && W(e.messageCompiler) && wt(he(Z.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const b = W(e.messageResolver) ? e.messageResolver : wn || Fs, v = W(e.localeFallbacker) ? e.localeFallbacker : Vn || vs, g = F(e.fallbackContext) ? e.fallbackContext : void 0, R = e, w = F(R.__datetimeFormatters) ? R.__datetimeFormatters : /* @__PURE__ */ new Map(), B = F(R.__numberFormatters) ? R.__numberFormatters : /* @__PURE__ */ new Map(), ne = F(R.__meta) ? R.__meta : {};
  un++;
  const X = {
    version: n,
    cid: un,
    locale: r,
    fallbackLocale: a,
    messages: o,
    modifiers: E,
    pluralRules: O,
    missing: L,
    missingWarn: N,
    fallbackWarn: C,
    fallbackFormat: P,
    unresolving: A,
    postTranslation: S,
    processor: f,
    warnHtmlMessage: m,
    escapeParameter: h,
    messageCompiler: d,
    messageResolver: b,
    localeFallbacker: v,
    fallbackContext: g,
    onWarn: t,
    __meta: ne
  };
  return X.datetimeFormats = c, X.numberFormats = u, X.__datetimeFormatters = w, X.__numberFormatters = B, process.env.NODE_ENV !== "production" && (X.__v_emitter = R.__v_emitter != null ? R.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Ls(X, n, ne), X;
}
const Tt = (e) => ({ [e]: $() });
function et(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Gn(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function xt(e, t, n, r, s) {
  const { missing: a, onWarn: o } = e;
  if (process.env.NODE_ENV !== "production") {
    const c = e.__v_emitter;
    c && c.emit("missing", {
      locale: n,
      key: t,
      type: s,
      groupId: `${s}:${t}`
    });
  }
  if (a !== null) {
    const c = a(e, n, t, s);
    return I(c) ? c : t;
  } else
    return process.env.NODE_ENV !== "production" && Gn(r, t) && o(he(Z.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function Me(e, t, n) {
  const r = e;
  r.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function xn(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function Bs(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let r = n + 1; r < t.length; r++)
    if (xn(e, t[r]))
      return !0;
  return !1;
}
const fn = typeof Intl < "u", Yn = {
  dateTimeFormat: fn && typeof Intl.DateTimeFormat < "u",
  numberFormat: fn && typeof Intl.NumberFormat < "u"
};
function _n(e, ...t) {
  const { datetimeFormats: n, unresolving: r, fallbackLocale: s, onWarn: a, localeFallbacker: o } = e, { __datetimeFormatters: c } = e;
  if (process.env.NODE_ENV !== "production" && !Yn.dateTimeFormat)
    return a(he(Z.CANNOT_FORMAT_DATE)), Qe;
  const [u, E, O, L] = It(...t), N = M(O.missingWarn) ? O.missingWarn : e.missingWarn, C = M(O.fallbackWarn) ? O.fallbackWarn : e.fallbackWarn, P = !!O.part, A = Gt(e, O), S = o(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    A
  );
  if (!I(u) || u === "")
    return new Intl.DateTimeFormat(A, L).format(E);
  let f = {}, m, h = null, d = A, b = null;
  const v = "datetime format";
  for (let w = 0; w < S.length; w++) {
    if (m = b = S[w], process.env.NODE_ENV !== "production" && A !== m && et(C, u) && a(he(Z.FALLBACK_TO_DATE_FORMAT, {
      key: u,
      target: m
    })), process.env.NODE_ENV !== "production" && A !== m) {
      const B = e.__v_emitter;
      B && B.emit("fallback", {
        type: v,
        key: u,
        from: d,
        to: b,
        groupId: `${v}:${u}`
      });
    }
    if (f = n[m] || {}, h = f[u], k(h))
      break;
    xt(e, u, m, N, v), d = b;
  }
  if (!k(h) || !I(m))
    return r ? ze : u;
  let g = `${m}__${u}`;
  Ze(L) || (g = `${g}__${JSON.stringify(L)}`);
  let R = c.get(g);
  return R || (R = new Intl.DateTimeFormat(m, J({}, h, L)), c.set(g, R)), P ? R.formatToParts(E) : R.format(E);
}
const Hn = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function It(...e) {
  const [t, n, r, s] = e, a = $();
  let o = $(), c;
  if (I(t)) {
    const u = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!u)
      throw ue(Q.INVALID_ISO_DATE_ARGUMENT);
    const E = u[3] ? u[3].trim().startsWith("T") ? `${u[1].trim()}${u[3].trim()}` : `${u[1].trim()}T${u[3].trim()}` : u[1].trim();
    c = new Date(E);
    try {
      c.toISOString();
    } catch {
      throw ue(Q.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (pr(t)) {
    if (isNaN(t.getTime()))
      throw ue(Q.INVALID_DATE_ARGUMENT);
    c = t;
  } else if (j(t))
    c = t;
  else
    throw ue(Q.INVALID_ARGUMENT);
  return I(n) ? a.key = n : k(n) && Object.keys(n).forEach((u) => {
    Hn.includes(u) ? o[u] = n[u] : a[u] = n[u];
  }), I(r) ? a.locale = r : k(r) && (o = r), k(s) && (o = s), [a.key || "", c, a, o];
}
function mn(e, t, n) {
  const r = e;
  for (const s in n) {
    const a = `${t}__${s}`;
    r.__datetimeFormatters.has(a) && r.__datetimeFormatters.delete(a);
  }
}
function dn(e, ...t) {
  const { numberFormats: n, unresolving: r, fallbackLocale: s, onWarn: a, localeFallbacker: o } = e, { __numberFormatters: c } = e;
  if (process.env.NODE_ENV !== "production" && !Yn.numberFormat)
    return a(he(Z.CANNOT_FORMAT_NUMBER)), Qe;
  const [u, E, O, L] = vt(...t), N = M(O.missingWarn) ? O.missingWarn : e.missingWarn, C = M(O.fallbackWarn) ? O.fallbackWarn : e.fallbackWarn, P = !!O.part, A = Gt(e, O), S = o(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    A
  );
  if (!I(u) || u === "")
    return new Intl.NumberFormat(A, L).format(E);
  let f = {}, m, h = null, d = A, b = null;
  const v = "number format";
  for (let w = 0; w < S.length; w++) {
    if (m = b = S[w], process.env.NODE_ENV !== "production" && A !== m && et(C, u) && a(he(Z.FALLBACK_TO_NUMBER_FORMAT, {
      key: u,
      target: m
    })), process.env.NODE_ENV !== "production" && A !== m) {
      const B = e.__v_emitter;
      B && B.emit("fallback", {
        type: v,
        key: u,
        from: d,
        to: b,
        groupId: `${v}:${u}`
      });
    }
    if (f = n[m] || {}, h = f[u], k(h))
      break;
    xt(e, u, m, N, v), d = b;
  }
  if (!k(h) || !I(m))
    return r ? ze : u;
  let g = `${m}__${u}`;
  Ze(L) || (g = `${g}__${JSON.stringify(L)}`);
  let R = c.get(g);
  return R || (R = new Intl.NumberFormat(m, J({}, h, L)), c.set(g, R)), P ? R.formatToParts(E) : R.format(E);
}
const Kn = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function vt(...e) {
  const [t, n, r, s] = e, a = $();
  let o = $();
  if (!j(t))
    throw ue(Q.INVALID_ARGUMENT);
  const c = t;
  return I(n) ? a.key = n : k(n) && Object.keys(n).forEach((u) => {
    Kn.includes(u) ? o[u] = n[u] : a[u] = n[u];
  }), I(r) ? a.locale = r : k(r) && (o = r), k(s) && (o = s), [a.key || "", c, a, o];
}
function En(e, t, n) {
  const r = e;
  for (const s in n) {
    const a = `${t}__${s}`;
    r.__numberFormatters.has(a) && r.__numberFormatters.delete(a);
  }
}
const Xs = (e) => e, Js = (e) => "", Qs = "text", qs = (e) => e.length === 0 ? "" : Ut(e), Zs = hr;
function gn(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function zs(e) {
  const t = j(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (j(e.named.count) || j(e.named.n)) ? j(e.named.count) ? e.named.count : j(e.named.n) ? e.named.n : t : t;
}
function ea(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function ta(e = {}) {
  const t = e.locale, n = zs(e), r = F(e.pluralRules) && I(t) && W(e.pluralRules[t]) ? e.pluralRules[t] : gn, s = F(e.pluralRules) && I(t) && W(e.pluralRules[t]) ? gn : void 0, a = (f) => f[r(n, f.length, s)], o = e.list || [], c = (f) => o[f], u = e.named || $();
  j(e.pluralIndex) && ea(n, u);
  const E = (f) => u[f];
  function O(f, m) {
    const h = W(e.messages) ? e.messages(f, !!m) : F(e.messages) ? e.messages[f] : !1;
    return h || (e.parent ? e.parent.message(f) : Js);
  }
  const L = (f) => e.modifiers ? e.modifiers[f] : Xs, N = k(e.processor) && W(e.processor.normalize) ? e.processor.normalize : qs, C = k(e.processor) && W(e.processor.interpolate) ? e.processor.interpolate : Zs, P = k(e.processor) && I(e.processor.type) ? e.processor.type : Qs, S = {
    list: c,
    named: E,
    plural: a,
    linked: (f, ...m) => {
      const [h, d] = m;
      let b = "text", v = "";
      m.length === 1 ? F(h) ? (v = h.modifier || v, b = h.type || b) : I(h) && (v = h || v) : m.length === 2 && (I(h) && (v = h || v), I(d) && (b = d || b));
      const g = O(f, !0)(S), R = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        b === "vnode" && K(g) && v ? g[0] : g
      );
      return v ? L(v)(R, b) : R;
    },
    message: O,
    type: P,
    interpolate: C,
    normalize: N,
    values: J($(), o, u)
  };
  return S;
}
const pn = () => "", te = (e) => W(e);
function Nn(e, ...t) {
  const { fallbackFormat: n, postTranslation: r, unresolving: s, messageCompiler: a, fallbackLocale: o, messages: c } = e, [u, E] = At(...t), O = M(E.missingWarn) ? E.missingWarn : e.missingWarn, L = M(E.fallbackWarn) ? E.fallbackWarn : e.fallbackWarn, N = M(E.escapeParameter) ? E.escapeParameter : e.escapeParameter, C = !!E.resolvedMessage, P = I(E.default) || M(E.default) ? M(E.default) ? a ? u : () => u : E.default : n ? a ? u : () => u : null, A = n || P != null && (I(P) || W(P)), S = Gt(e, E);
  N && na(E);
  let [f, m, h] = C ? [
    u,
    S,
    c[S] || $()
  ] : jn(e, u, S, o, L, O), d = f, b = u;
  if (!C && !(I(d) || _e(d) || te(d)) && A && (d = P, b = d), !C && (!(I(d) || _e(d) || te(d)) || !I(m)))
    return s ? ze : u;
  if (process.env.NODE_ENV !== "production" && I(d) && e.messageCompiler == null)
    return me(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${u}'.`), u;
  let v = !1;
  const g = () => {
    v = !0;
  }, R = te(d) ? d : Bn(e, u, m, d, b, g);
  if (v)
    return d;
  const w = oa(e, m, h, E), B = ta(w), ne = ra(e, R, B), X = r ? r(ne, u) : ne;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const be = {
      timestamp: Date.now(),
      key: I(u) ? u : te(d) ? d.key : "",
      locale: m || (te(d) ? d.locale : ""),
      format: I(d) ? d : te(d) ? d.source : "",
      message: X
    };
    be.meta = J({}, e.__meta, /* @__PURE__ */ Hs() || {}), hs(be);
  }
  return X;
}
function na(e) {
  K(e.list) ? e.list = e.list.map((t) => I(t) ? qt(t) : t) : F(e.named) && Object.keys(e.named).forEach((t) => {
    I(e.named[t]) && (e.named[t] = qt(e.named[t]));
  });
}
function jn(e, t, n, r, s, a) {
  const { messages: o, onWarn: c, messageResolver: u, localeFallbacker: E } = e, O = E(e, r, n);
  let L = $(), N, C = null, P = n, A = null;
  const S = "translate";
  for (let f = 0; f < O.length; f++) {
    if (N = A = O[f], process.env.NODE_ENV !== "production" && n !== N && !xn(n, N) && et(s, t) && c(he(Z.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: N
    })), process.env.NODE_ENV !== "production" && n !== N) {
      const b = e.__v_emitter;
      b && b.emit("fallback", {
        type: S,
        key: t,
        from: P,
        to: A,
        groupId: `${S}:${t}`
      });
    }
    L = o[N] || $();
    let m = null, h, d;
    if (process.env.NODE_ENV !== "production" && se && (m = window.performance.now(), h = "intlify-message-resolve-start", d = "intlify-message-resolve-end", ee && ee(h)), (C = u(L, t)) === null && (C = L[t]), process.env.NODE_ENV !== "production" && se) {
      const b = window.performance.now(), v = e.__v_emitter;
      v && m && C && v.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: C,
        time: b - m,
        groupId: `${S}:${t}`
      }), h && d && ee && Le && (ee(d), Le("intlify message resolve", h, d));
    }
    if (I(C) || _e(C) || te(C))
      break;
    if (!Bs(N, O)) {
      const b = xt(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        N,
        a,
        S
      );
      b !== t && (C = b);
    }
    P = A;
  }
  return [C, N, L];
}
function Bn(e, t, n, r, s, a) {
  const { messageCompiler: o, warnHtmlMessage: c } = e;
  if (te(r)) {
    const N = r;
    return N.locale = N.locale || n, N.key = N.key || t, N;
  }
  if (o == null) {
    const N = () => r;
    return N.locale = n, N.key = t, N;
  }
  let u = null, E, O;
  process.env.NODE_ENV !== "production" && se && (u = window.performance.now(), E = "intlify-message-compilation-start", O = "intlify-message-compilation-end", ee && ee(E));
  const L = o(r, sa(e, n, s, r, c, a));
  if (process.env.NODE_ENV !== "production" && se) {
    const N = window.performance.now(), C = e.__v_emitter;
    C && u && C.emit("message-compilation", {
      type: "message-compilation",
      message: r,
      time: N - u,
      groupId: `translate:${t}`
    }), E && O && ee && Le && (ee(O), Le("intlify message compilation", E, O));
  }
  return L.locale = n, L.key = t, L.source = r, L;
}
function ra(e, t, n) {
  let r = null, s, a;
  process.env.NODE_ENV !== "production" && se && (r = window.performance.now(), s = "intlify-message-evaluation-start", a = "intlify-message-evaluation-end", ee && ee(s));
  const o = t(n);
  if (process.env.NODE_ENV !== "production" && se) {
    const c = window.performance.now(), u = e.__v_emitter;
    u && r && u.emit("message-evaluation", {
      type: "message-evaluation",
      value: o,
      time: c - r,
      groupId: `translate:${t.key}`
    }), s && a && ee && Le && (ee(a), Le("intlify message evaluation", s, a));
  }
  return o;
}
function At(...e) {
  const [t, n, r] = e, s = $();
  if (!I(t) && !j(t) && !te(t) && !_e(t))
    throw ue(Q.INVALID_ARGUMENT);
  const a = j(t) ? String(t) : (te(t), t);
  return j(n) ? s.plural = n : I(n) ? s.default = n : k(n) && !Ze(n) ? s.named = n : K(n) && (s.list = n), j(r) ? s.plural = r : I(r) ? s.default = r : k(r) && J(s, r), [a, s];
}
function sa(e, t, n, r, s, a) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: s,
    onError: (o) => {
      if (a && a(o), process.env.NODE_ENV !== "production") {
        const c = aa(r), u = `Message compilation error: ${o.message}`, E = o.location && c && Or(c, o.location.start.offset, o.location.end.offset), O = e.__v_emitter;
        O && c && O.emit("compile-error", {
          message: c,
          error: o.message,
          start: o.location && o.location.start.offset,
          end: o.location && o.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(E ? `${u}
${E}` : u);
      } else
        throw o;
    },
    onCacheKey: (o) => Er(t, n, o)
  };
}
function aa(e) {
  if (I(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function oa(e, t, n, r) {
  const { modifiers: s, pluralRules: a, messageResolver: o, fallbackLocale: c, fallbackWarn: u, missingWarn: E, fallbackContext: O } = e, N = {
    locale: t,
    modifiers: s,
    pluralRules: a,
    messages: (C, P) => {
      let A = o(n, C);
      if (A == null && (O || P)) {
        const [, , S] = jn(
          O || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          C,
          t,
          c,
          u,
          E
        );
        A = o(S, C);
      }
      if (I(A) || _e(A)) {
        let S = !1;
        const m = Bn(e, C, t, A, C, () => {
          S = !0;
        });
        return S ? pn : m;
      } else return te(A) ? A : pn;
    }
  };
  return e.processor && (N.processor = e.processor), r.list && (N.list = r.list), r.named && (N.named = r.named), j(r.plural) && (N.pluralIndex = r.plural), N;
}
Zr();
function la() {
  return Xn().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function Xn() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const ia = typeof Proxy == "function", ca = "devtools-plugin:setup", ua = "plugin:settings:set";
let ve, Ct;
function fa() {
  var e;
  return ve !== void 0 || (typeof window < "u" && window.performance ? (ve = !0, Ct = window.performance) : typeof globalThis < "u" && (!((e = globalThis.perf_hooks) === null || e === void 0) && e.performance) ? (ve = !0, Ct = globalThis.perf_hooks.performance) : ve = !1), ve;
}
function _a() {
  return fa() ? Ct.now() : Date.now();
}
class ma {
  constructor(t, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = n;
    const r = {};
    if (t.settings)
      for (const o in t.settings) {
        const c = t.settings[o];
        r[o] = c.defaultValue;
      }
    const s = `__vue-devtools-plugin-settings__${t.id}`;
    let a = Object.assign({}, r);
    try {
      const o = localStorage.getItem(s), c = JSON.parse(o);
      Object.assign(a, c);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return a;
      },
      setSettings(o) {
        try {
          localStorage.setItem(s, JSON.stringify(o));
        } catch {
        }
        a = o;
      },
      now() {
        return _a();
      }
    }, n && n.on(ua, (o, c) => {
      o === this.plugin.id && this.fallbacks.setSettings(c);
    }), this.proxiedOn = new Proxy({}, {
      get: (o, c) => this.target ? this.target.on[c] : (...u) => {
        this.onQueue.push({
          method: c,
          args: u
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (o, c) => this.target ? this.target[c] : c === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(c) ? (...u) => (this.targetQueue.push({
        method: c,
        args: u,
        resolve: () => {
        }
      }), this.fallbacks[c](...u)) : (...u) => new Promise((E) => {
        this.targetQueue.push({
          method: c,
          args: u,
          resolve: E
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function da(e, t) {
  const n = e, r = Xn(), s = la(), a = ia && n.enableEarlyProxy;
  if (s && (r.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !a))
    s.emit(ca, e, t);
  else {
    const o = a ? new ma(n, s) : null;
    (r.__VUE_DEVTOOLS_PLUGINS__ = r.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: t,
      proxy: o
    }), o && t(o.proxiedTarget);
  }
}
/*!
  * vue-i18n v11.1.2
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const Ea = "11.1.2";
function ga() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Te().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Te().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Te().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Te().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const G = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: bs,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function z(e, ...t) {
  return De(e, null, process.env.NODE_ENV !== "production" ? { messages: pa, args: t } : void 0);
}
const pa = {
  [G.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [G.INVALID_ARGUMENT]: "Invalid argument",
  [G.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [G.NOT_INSTALLED]: "Need to install with `app.use` function",
  [G.UNEXPECTED_ERROR]: "Unexpected error",
  [G.REQUIRED_VALUE]: "Required in value: {0}",
  [G.INVALID_VALUE]: "Invalid value",
  [G.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [G.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [G.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [G.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, St = /* @__PURE__ */ le("__translateVNode"), Dt = /* @__PURE__ */ le("__datetimeParts"), Pt = /* @__PURE__ */ le("__numberParts"), Oe = /* @__PURE__ */ le("__enableEmitter"), We = /* @__PURE__ */ le("__disableEmitter"), Jn = le("__setPluralRules"), Qn = /* @__PURE__ */ le("__injectWithOption"), yt = /* @__PURE__ */ le("__dispose"), oe = {
  FALLBACK_TO_ROOT: Us,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: 11,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: 12
}, Na = {
  [oe.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [oe.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [oe.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [oe.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [oe.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead."
};
function Ye(e, ...t) {
  return qe(Na[e], ...t);
}
function Ge(e) {
  if (!F(e))
    return e;
  for (const t in e)
    if (re(e, t))
      if (!t.includes("."))
        F(e[t]) && Ge(e[t]);
      else {
        const n = t.split("."), r = n.length - 1;
        let s = e, a = !1;
        for (let o = 0; o < r; o++) {
          if (n[o] === "__proto__")
            throw new Error(`unsafe key: ${n[o]}`);
          if (n[o] in s || (s[n[o]] = $()), !F(s[n[o]])) {
            process.env.NODE_ENV !== "production" && me(Ye(oe.IGNORE_OBJ_FLATTEN, {
              key: n[o]
            })), a = !0;
            break;
          }
          s = s[n[o]];
        }
        a || (s[n[r]] = e[t], delete e[t]), F(s[n[r]]) && Ge(s[n[r]]);
      }
  return e;
}
function Yt(e, t) {
  const { messages: n, __i18n: r, messageResolver: s, flatJson: a } = t, o = k(n) ? n : K(r) ? $() : { [e]: $() };
  if (K(r) && r.forEach((c) => {
    if ("locale" in c && "resource" in c) {
      const { locale: u, resource: E } = c;
      u ? (o[u] = o[u] || $(), Je(E, o[u])) : Je(E, o);
    } else
      I(c) && Je(JSON.parse(c), o);
  }), s == null && a)
    for (const c in o)
      re(o, c) && Ge(o[c]);
  return o;
}
function qn(e) {
  return e.type;
}
function Zn(e, t, n) {
  let r = F(t.messages) ? t.messages : $();
  "__i18nGlobal" in n && (r = Yt(e.locale.value, {
    messages: r,
    __i18n: n.__i18nGlobal
  }));
  const s = Object.keys(r);
  s.length && s.forEach((a) => {
    e.mergeLocaleMessage(a, r[a]);
  });
  {
    if (F(t.datetimeFormats)) {
      const a = Object.keys(t.datetimeFormats);
      a.length && a.forEach((o) => {
        e.mergeDateTimeFormat(o, t.datetimeFormats[o]);
      });
    }
    if (F(t.numberFormats)) {
      const a = Object.keys(t.numberFormats);
      a.length && a.forEach((o) => {
        e.mergeNumberFormat(o, t.numberFormats[o]);
      });
    }
  }
}
function Tn(e) {
  return _r(mr, null, e, 0);
}
const Ln = "__INTLIFY_META__", hn = () => [], Ta = () => !1;
let On = 0;
function bn(e) {
  return (t, n, r, s) => e(n, r, Ue() || void 0, s);
}
const La = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = Ue();
  let t = null;
  return e && (t = qn(e)[Ln]) ? { [Ln]: t } : null;
};
function Ht(e = {}) {
  const { __root: t, __injectWithOption: n } = e, r = t === void 0, s = e.flatJson, a = se ? or : lr;
  let o = M(e.inheritLocale) ? e.inheritLocale : !0;
  const c = a(
    // prettier-ignore
    t && o ? t.locale.value : I(e.locale) ? e.locale : $e
  ), u = a(
    // prettier-ignore
    t && o ? t.fallbackLocale.value : I(e.fallbackLocale) || K(e.fallbackLocale) || k(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : c.value
  ), E = a(Yt(c.value, e)), O = a(k(e.datetimeFormats) ? e.datetimeFormats : { [c.value]: {} }), L = a(k(e.numberFormats) ? e.numberFormats : { [c.value]: {} });
  let N = t ? t.missingWarn : M(e.missingWarn) || Ce(e.missingWarn) ? e.missingWarn : !0, C = t ? t.fallbackWarn : M(e.fallbackWarn) || Ce(e.fallbackWarn) ? e.fallbackWarn : !0, P = t ? t.fallbackRoot : M(e.fallbackRoot) ? e.fallbackRoot : !0, A = !!e.fallbackFormat, S = W(e.missing) ? e.missing : null, f = W(e.missing) ? bn(e.missing) : null, m = W(e.postTranslation) ? e.postTranslation : null, h = t ? t.warnHtmlMessage : M(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, d = !!e.escapeParameter;
  const b = t ? t.modifiers : k(e.modifiers) ? e.modifiers : {};
  let v = e.pluralRules || t && t.pluralRules, g;
  g = (() => {
    r && cn(null);
    const _ = {
      version: Ea,
      locale: c.value,
      fallbackLocale: u.value,
      messages: E.value,
      modifiers: b,
      pluralRules: v,
      missing: f === null ? void 0 : f,
      missingWarn: N,
      fallbackWarn: C,
      fallbackFormat: A,
      unresolving: !0,
      postTranslation: m === null ? void 0 : m,
      warnHtmlMessage: h,
      escapeParameter: d,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    _.datetimeFormats = O.value, _.numberFormats = L.value, _.__datetimeFormatters = k(g) ? g.__datetimeFormatters : void 0, _.__numberFormatters = k(g) ? g.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (_.__v_emitter = k(g) ? g.__v_emitter : void 0);
    const T = js(_);
    return r && cn(T), T;
  })(), Me(g, c.value, u.value);
  function w() {
    return [
      c.value,
      u.value,
      E.value,
      O.value,
      L.value
    ];
  }
  const B = Fe({
    get: () => c.value,
    set: (_) => {
      g.locale = _, c.value = _;
    }
  }), ne = Fe({
    get: () => u.value,
    set: (_) => {
      g.fallbackLocale = _, u.value = _, Me(g, c.value, _);
    }
  }), X = Fe(() => E.value), be = /* @__PURE__ */ Fe(() => O.value), tt = /* @__PURE__ */ Fe(() => L.value);
  function nt() {
    return W(m) ? m : null;
  }
  function rt(_) {
    m = _, g.postTranslation = _;
  }
  function st() {
    return S;
  }
  function at(_) {
    _ !== null && (f = bn(_)), S = _, g.missing = f;
  }
  function ot(_, T) {
    return _ !== "translate" || !T.resolvedMessage;
  }
  const ie = (_, T, V, H, pe, Ke) => {
    w();
    let Ie;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, r || (g.fallbackContext = t ? Ks() : void 0), Ie = _(g);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, r || (g.fallbackContext = void 0);
    }
    if (V !== "translate exists" && // for not `te` (e.g `t`)
    j(Ie) && Ie === ze || V === "translate exists" && !Ie) {
      const [Ne, sr] = T();
      if (process.env.NODE_ENV !== "production" && t && I(Ne) && ot(V, sr) && (P && (et(C, Ne) || Gn(N, Ne)) && me(Ye(oe.FALLBACK_TO_ROOT, {
        key: Ne,
        type: V
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Jt } = g;
        Jt && P && Jt.emit("fallback", {
          type: V,
          key: Ne,
          to: "global",
          groupId: `${V}:${Ne}`
        });
      }
      return t && P ? H(t) : pe(Ne);
    } else {
      if (Ke(Ie))
        return Ie;
      throw z(G.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Pe(..._) {
    return ie((T) => Reflect.apply(Nn, null, [T, ..._]), () => At(..._), "translate", (T) => Reflect.apply(T.t, T, [..._]), (T) => T, (T) => I(T));
  }
  function lt(..._) {
    const [T, V, H] = _;
    if (H && !F(H))
      throw z(G.INVALID_ARGUMENT);
    return Pe(T, V, J({ resolvedMessage: !0 }, H || {}));
  }
  function it(..._) {
    return ie((T) => Reflect.apply(_n, null, [T, ..._]), () => It(..._), "datetime format", (T) => Reflect.apply(T.d, T, [..._]), () => Qe, (T) => I(T));
  }
  function ct(..._) {
    return ie((T) => Reflect.apply(dn, null, [T, ..._]), () => vt(..._), "number format", (T) => Reflect.apply(T.n, T, [..._]), () => Qe, (T) => I(T));
  }
  function ut(_) {
    return _.map((T) => I(T) || j(T) || M(T) ? Tn(String(T)) : T);
  }
  const ft = {
    normalize: ut,
    interpolate: (_) => _,
    type: "vnode"
  };
  function He(..._) {
    return ie((T) => {
      let V;
      const H = T;
      try {
        H.processor = ft, V = Reflect.apply(Nn, null, [H, ..._]);
      } finally {
        H.processor = null;
      }
      return V;
    }, () => At(..._), "translate", (T) => T[St](..._), (T) => [Tn(T)], (T) => K(T));
  }
  function _t(..._) {
    return ie((T) => Reflect.apply(dn, null, [T, ..._]), () => vt(..._), "number format", (T) => T[Pt](..._), hn, (T) => I(T) || K(T));
  }
  function mt(..._) {
    return ie((T) => Reflect.apply(_n, null, [T, ..._]), () => It(..._), "datetime format", (T) => T[Dt](..._), hn, (T) => I(T) || K(T));
  }
  function dt(_) {
    v = _, g.pluralRules = v;
  }
  function Et(_, T) {
    return ie(() => {
      if (!_)
        return !1;
      const V = I(T) ? T : c.value, H = ge(V), pe = g.messageResolver(H, _);
      return _e(pe) || te(pe) || I(pe);
    }, () => [_], "translate exists", (V) => Reflect.apply(V.te, V, [_, T]), Ta, (V) => M(V));
  }
  function ye(_) {
    let T = null;
    const V = Mn(g, u.value, c.value);
    for (let H = 0; H < V.length; H++) {
      const pe = E.value[V[H]] || {}, Ke = g.messageResolver(pe, _);
      if (Ke != null) {
        T = Ke;
        break;
      }
    }
    return T;
  }
  function Re(_) {
    const T = ye(_);
    return T ?? (t ? t.tm(_) || {} : {});
  }
  function ge(_) {
    return E.value[_] || {};
  }
  function ke(_, T) {
    if (s) {
      const V = { [_]: T };
      for (const H in V)
        re(V, H) && Ge(V[H]);
      T = V[_];
    }
    E.value[_] = T, g.messages = E.value;
  }
  function gt(_, T) {
    E.value[_] = E.value[_] || {};
    const V = { [_]: T };
    if (s)
      for (const H in V)
        re(V, H) && Ge(V[H]);
    T = V[_], Je(T, E.value[_]), g.messages = E.value;
  }
  function l(_) {
    return O.value[_] || {};
  }
  function i(_, T) {
    O.value[_] = T, g.datetimeFormats = O.value, mn(g, _, T);
  }
  function p(_, T) {
    O.value[_] = J(O.value[_] || {}, T), g.datetimeFormats = O.value, mn(g, _, T);
  }
  function D(_) {
    return L.value[_] || {};
  }
  function x(_, T) {
    L.value[_] = T, g.numberFormats = L.value, En(g, _, T);
  }
  function Y(_, T) {
    L.value[_] = J(L.value[_] || {}, T), g.numberFormats = L.value, En(g, _, T);
  }
  On++, t && se && (ht(t.locale, (_) => {
    o && (c.value = _, g.locale = _, Me(g, c.value, u.value));
  }), ht(t.fallbackLocale, (_) => {
    o && (u.value = _, g.fallbackLocale = _, Me(g, c.value, u.value));
  }));
  const U = {
    id: On,
    locale: B,
    fallbackLocale: ne,
    get inheritLocale() {
      return o;
    },
    set inheritLocale(_) {
      o = _, _ && t && (c.value = t.locale.value, u.value = t.fallbackLocale.value, Me(g, c.value, u.value));
    },
    get availableLocales() {
      return Object.keys(E.value).sort();
    },
    messages: X,
    get modifiers() {
      return b;
    },
    get pluralRules() {
      return v || {};
    },
    get isGlobal() {
      return r;
    },
    get missingWarn() {
      return N;
    },
    set missingWarn(_) {
      N = _, g.missingWarn = N;
    },
    get fallbackWarn() {
      return C;
    },
    set fallbackWarn(_) {
      C = _, g.fallbackWarn = C;
    },
    get fallbackRoot() {
      return P;
    },
    set fallbackRoot(_) {
      P = _;
    },
    get fallbackFormat() {
      return A;
    },
    set fallbackFormat(_) {
      A = _, g.fallbackFormat = A;
    },
    get warnHtmlMessage() {
      return h;
    },
    set warnHtmlMessage(_) {
      h = _, g.warnHtmlMessage = _;
    },
    get escapeParameter() {
      return d;
    },
    set escapeParameter(_) {
      d = _, g.escapeParameter = _;
    },
    t: Pe,
    getLocaleMessage: ge,
    setLocaleMessage: ke,
    mergeLocaleMessage: gt,
    getPostTranslationHandler: nt,
    setPostTranslationHandler: rt,
    getMissingHandler: st,
    setMissingHandler: at,
    [Jn]: dt
  };
  return U.datetimeFormats = be, U.numberFormats = tt, U.rt = lt, U.te = Et, U.tm = Re, U.d = it, U.n = ct, U.getDateTimeFormat = l, U.setDateTimeFormat = i, U.mergeDateTimeFormat = p, U.getNumberFormat = D, U.setNumberFormat = x, U.mergeNumberFormat = Y, U[Qn] = n, U[St] = He, U[Dt] = mt, U[Pt] = _t, process.env.NODE_ENV !== "production" && (U[Oe] = (_) => {
    g.__v_emitter = _;
  }, U[We] = () => {
    g.__v_emitter = void 0;
  }), U;
}
const zn = "vue-i18n: composer properties", Lt = {
  "vue-devtools-plugin-vue-i18n": "Vue I18n DevTools",
  "vue-i18n-resource-inspector": "Vue I18n DevTools",
  "vue-i18n-timeline": "Vue I18n"
}, ha = {
  "vue-i18n-resource-inspector": "Search for scopes ..."
}, Oa = {
  "vue-i18n-timeline": 16764185
};
let Rt;
async function ba(e, t) {
  return new Promise((n, r) => {
    try {
      da({
        id: "vue-devtools-plugin-vue-i18n",
        label: Lt["vue-devtools-plugin-vue-i18n"],
        packageName: "vue-i18n",
        homepage: "https://vue-i18n.intlify.dev",
        logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
        componentStateTypes: [zn],
        app: e
        // eslint-disable-line @typescript-eslint/no-explicit-any
      }, (s) => {
        Rt = s, s.on.visitComponentTree(({ componentInstance: o, treeNode: c }) => {
          Ia(o, c, t);
        }), s.on.inspectComponent(({ componentInstance: o, instanceData: c }) => {
          o.vnode.el && o.vnode.el.__VUE_I18N__ && c && (t.mode === "legacy" ? o.vnode.el.__VUE_I18N__ !== t.global.__composer && In(c, o.vnode.el.__VUE_I18N__) : In(c, o.vnode.el.__VUE_I18N__));
        }), s.addInspector({
          id: "vue-i18n-resource-inspector",
          label: Lt["vue-i18n-resource-inspector"],
          icon: "language",
          treeFilterPlaceholder: ha["vue-i18n-resource-inspector"]
        }), s.on.getInspectorTree((o) => {
          o.app === e && o.inspectorId === "vue-i18n-resource-inspector" && Da(o, t);
        });
        const a = /* @__PURE__ */ new Map();
        s.on.getInspectorState(async (o) => {
          if (o.app === e && o.inspectorId === "vue-i18n-resource-inspector")
            if (s.unhighlightElement(), ya(o, t), o.nodeId === "global") {
              if (!a.has(o.app)) {
                const [c] = await s.getComponentInstances(o.app);
                a.set(o.app, c);
              }
              s.highlightElement(a.get(o.app));
            } else {
              const c = Pa(o.nodeId, t);
              c && s.highlightElement(c);
            }
        }), s.on.editInspectorState((o) => {
          o.app === e && o.inspectorId === "vue-i18n-resource-inspector" && ka(o, t);
        }), s.addTimelineLayer({
          id: "vue-i18n-timeline",
          label: Lt["vue-i18n-timeline"],
          color: Oa["vue-i18n-timeline"]
        }), n(!0);
      });
    } catch (s) {
      console.error(s), r(!1);
    }
  });
}
function er(e) {
  return e.type.name || e.type.displayName || e.type.__file || "Anonymous";
}
function Ia(e, t, n) {
  const r = n.mode === "composition" ? n.global : n.global.__composer;
  if (e && e.vnode.el && e.vnode.el.__VUE_I18N__ && e.vnode.el.__VUE_I18N__ !== r) {
    const s = {
      label: `i18n (${er(e)} Scope)`,
      textColor: 0,
      backgroundColor: 16764185
    };
    t.tags.push(s);
  }
}
function In(e, t) {
  const n = zn;
  e.state.push({
    type: n,
    key: "locale",
    editable: !0,
    value: t.locale.value
  }), e.state.push({
    type: n,
    key: "availableLocales",
    editable: !1,
    value: t.availableLocales
  }), e.state.push({
    type: n,
    key: "fallbackLocale",
    editable: !0,
    value: t.fallbackLocale.value
  }), e.state.push({
    type: n,
    key: "inheritLocale",
    editable: !0,
    value: t.inheritLocale
  }), e.state.push({
    type: n,
    key: "messages",
    editable: !1,
    value: Kt(t.messages.value)
  }), e.state.push({
    type: n,
    key: "datetimeFormats",
    editable: !1,
    value: t.datetimeFormats.value
  }), e.state.push({
    type: n,
    key: "numberFormats",
    editable: !1,
    value: t.numberFormats.value
  });
}
function Kt(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    const r = e[n];
    W(r) && "source" in r ? t[n] = Sa(r) : _e(r) && r.loc && r.loc.source ? t[n] = r.loc.source : F(r) ? t[n] = Kt(r) : t[n] = r;
  }), t;
}
const va = {
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "&": "&amp;"
};
function Aa(e) {
  return e.replace(/[<>"&]/g, Ca);
}
function Ca(e) {
  return va[e] || e;
}
function Sa(e) {
  return {
    _custom: {
      type: "function",
      display: `<span>ƒ</span> ${e.source ? `("${Aa(e.source)}")` : "(?)"}`
    }
  };
}
function Da(e, t) {
  e.rootNodes.push({
    id: "global",
    label: "Global Scope"
  });
  const n = t.mode === "composition" ? t.global : t.global.__composer;
  for (const [r, s] of t.__instances) {
    const a = t.mode === "composition" ? s : s.__composer;
    n !== a && e.rootNodes.push({
      id: a.id.toString(),
      label: `${er(r)} Scope`
    });
  }
}
function Pa(e, t) {
  let n = null;
  if (e !== "global") {
    for (const [r, s] of t.__instances.entries())
      if (s.id.toString() === e) {
        n = r;
        break;
      }
  }
  return n;
}
function tr(e, t) {
  if (e === "global")
    return t.mode === "composition" ? t.global : t.global.__composer;
  {
    const n = Array.from(t.__instances.values()).find((r) => r.id.toString() === e);
    return n ? t.mode === "composition" ? n : n.__composer : null;
  }
}
function ya(e, t) {
  const n = tr(e.nodeId, t);
  return n && (e.state = Ra(n)), null;
}
function Ra(e) {
  const t = {}, n = "Locale related info", r = [
    {
      type: n,
      key: "locale",
      editable: !0,
      value: e.locale.value
    },
    {
      type: n,
      key: "fallbackLocale",
      editable: !0,
      value: e.fallbackLocale.value
    },
    {
      type: n,
      key: "availableLocales",
      editable: !1,
      value: e.availableLocales
    },
    {
      type: n,
      key: "inheritLocale",
      editable: !0,
      value: e.inheritLocale
    }
  ];
  t[n] = r;
  const s = "Locale messages info", a = [
    {
      type: s,
      key: "messages",
      editable: !1,
      value: Kt(e.messages.value)
    }
  ];
  t[s] = a;
  {
    const o = "Datetime formats info", c = [
      {
        type: o,
        key: "datetimeFormats",
        editable: !1,
        value: e.datetimeFormats.value
      }
    ];
    t[o] = c;
    const u = "Datetime formats info", E = [
      {
        type: u,
        key: "numberFormats",
        editable: !1,
        value: e.numberFormats.value
      }
    ];
    t[u] = E;
  }
  return t;
}
function xe(e, t) {
  if (Rt) {
    let n;
    t && "groupId" in t && (n = t.groupId, delete t.groupId), Rt.addTimelineEvent({
      layerId: "vue-i18n-timeline",
      event: {
        title: e,
        groupId: n,
        time: Date.now(),
        meta: {},
        data: t || {},
        logType: e === "compile-error" ? "error" : e === "fallback" || e === "missing" ? "warning" : "default"
      }
    });
  }
}
function ka(e, t) {
  const n = tr(e.nodeId, t);
  if (n) {
    const [r] = e.path;
    r === "locale" && I(e.state.value) ? n.locale.value = e.state.value : r === "fallbackLocale" && (I(e.state.value) || K(e.state.value) || F(e.state.value)) ? n.fallbackLocale.value = e.state.value : r === "inheritLocale" && M(e.state.value) && (n.inheritLocale = e.state.value);
  }
}
function Fa(e) {
  const t = I(e.locale) ? e.locale : $e, n = I(e.fallbackLocale) || K(e.fallbackLocale) || k(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : t, r = W(e.missing) ? e.missing : void 0, s = M(e.silentTranslationWarn) || Ce(e.silentTranslationWarn) ? !e.silentTranslationWarn : !0, a = M(e.silentFallbackWarn) || Ce(e.silentFallbackWarn) ? !e.silentFallbackWarn : !0, o = M(e.fallbackRoot) ? e.fallbackRoot : !0, c = !!e.formatFallbackMessages, u = k(e.modifiers) ? e.modifiers : {}, E = e.pluralizationRules, O = W(e.postTranslation) ? e.postTranslation : void 0, L = I(e.warnHtmlInMessage) ? e.warnHtmlInMessage !== "off" : !0, N = !!e.escapeParameterHtml, C = M(e.sync) ? e.sync : !0;
  let P = e.messages;
  if (k(e.sharedMessages)) {
    const b = e.sharedMessages;
    P = Object.keys(b).reduce((g, R) => {
      const w = g[R] || (g[R] = {});
      return J(w, b[R]), g;
    }, P || {});
  }
  const { __i18n: A, __root: S, __injectWithOption: f } = e, m = e.datetimeFormats, h = e.numberFormats, d = e.flatJson;
  return {
    locale: t,
    fallbackLocale: n,
    messages: P,
    flatJson: d,
    datetimeFormats: m,
    numberFormats: h,
    missing: r,
    missingWarn: s,
    fallbackWarn: a,
    fallbackRoot: o,
    fallbackFormat: c,
    modifiers: u,
    pluralRules: E,
    postTranslation: O,
    warnHtmlMessage: L,
    escapeParameter: N,
    messageResolver: e.messageResolver,
    inheritLocale: C,
    __i18n: A,
    __root: S,
    __injectWithOption: f
  };
}
function kt(e = {}) {
  const t = Ht(Fa(e)), { __extender: n } = e, r = {
    // id
    id: t.id,
    // locale
    get locale() {
      return t.locale.value;
    },
    set locale(s) {
      t.locale.value = s;
    },
    // fallbackLocale
    get fallbackLocale() {
      return t.fallbackLocale.value;
    },
    set fallbackLocale(s) {
      t.fallbackLocale.value = s;
    },
    // messages
    get messages() {
      return t.messages.value;
    },
    // datetimeFormats
    get datetimeFormats() {
      return t.datetimeFormats.value;
    },
    // numberFormats
    get numberFormats() {
      return t.numberFormats.value;
    },
    // availableLocales
    get availableLocales() {
      return t.availableLocales;
    },
    // missing
    get missing() {
      return t.getMissingHandler();
    },
    set missing(s) {
      t.setMissingHandler(s);
    },
    // silentTranslationWarn
    get silentTranslationWarn() {
      return M(t.missingWarn) ? !t.missingWarn : t.missingWarn;
    },
    set silentTranslationWarn(s) {
      t.missingWarn = M(s) ? !s : s;
    },
    // silentFallbackWarn
    get silentFallbackWarn() {
      return M(t.fallbackWarn) ? !t.fallbackWarn : t.fallbackWarn;
    },
    set silentFallbackWarn(s) {
      t.fallbackWarn = M(s) ? !s : s;
    },
    // modifiers
    get modifiers() {
      return t.modifiers;
    },
    // formatFallbackMessages
    get formatFallbackMessages() {
      return t.fallbackFormat;
    },
    set formatFallbackMessages(s) {
      t.fallbackFormat = s;
    },
    // postTranslation
    get postTranslation() {
      return t.getPostTranslationHandler();
    },
    set postTranslation(s) {
      t.setPostTranslationHandler(s);
    },
    // sync
    get sync() {
      return t.inheritLocale;
    },
    set sync(s) {
      t.inheritLocale = s;
    },
    // warnInHtmlMessage
    get warnHtmlInMessage() {
      return t.warnHtmlMessage ? "warn" : "off";
    },
    set warnHtmlInMessage(s) {
      t.warnHtmlMessage = s !== "off";
    },
    // escapeParameterHtml
    get escapeParameterHtml() {
      return t.escapeParameter;
    },
    set escapeParameterHtml(s) {
      t.escapeParameter = s;
    },
    // pluralizationRules
    get pluralizationRules() {
      return t.pluralRules || {};
    },
    // for internal
    __composer: t,
    // t
    t(...s) {
      return Reflect.apply(t.t, t, [...s]);
    },
    // rt
    rt(...s) {
      return Reflect.apply(t.rt, t, [...s]);
    },
    // te
    te(s, a) {
      return t.te(s, a);
    },
    // tm
    tm(s) {
      return t.tm(s);
    },
    // getLocaleMessage
    getLocaleMessage(s) {
      return t.getLocaleMessage(s);
    },
    // setLocaleMessage
    setLocaleMessage(s, a) {
      t.setLocaleMessage(s, a);
    },
    // mergeLocaleMessage
    mergeLocaleMessage(s, a) {
      t.mergeLocaleMessage(s, a);
    },
    // d
    d(...s) {
      return Reflect.apply(t.d, t, [...s]);
    },
    // getDateTimeFormat
    getDateTimeFormat(s) {
      return t.getDateTimeFormat(s);
    },
    // setDateTimeFormat
    setDateTimeFormat(s, a) {
      t.setDateTimeFormat(s, a);
    },
    // mergeDateTimeFormat
    mergeDateTimeFormat(s, a) {
      t.mergeDateTimeFormat(s, a);
    },
    // n
    n(...s) {
      return Reflect.apply(t.n, t, [...s]);
    },
    // getNumberFormat
    getNumberFormat(s) {
      return t.getNumberFormat(s);
    },
    // setNumberFormat
    setNumberFormat(s, a) {
      t.setNumberFormat(s, a);
    },
    // mergeNumberFormat
    mergeNumberFormat(s, a) {
      t.mergeNumberFormat(s, a);
    }
  };
  return r.__extender = n, process.env.NODE_ENV !== "production" && (r.__enableEmitter = (s) => {
    const a = t;
    a[Oe] && a[Oe](s);
  }, r.__disableEmitter = () => {
    const s = t;
    s[We] && s[We]();
  }), r;
}
function Ma(e, t, n) {
  return {
    beforeCreate() {
      const r = Ue();
      if (!r)
        throw z(G.UNEXPECTED_ERROR);
      const s = this.$options;
      if (s.i18n) {
        const a = s.i18n;
        if (s.__i18n && (a.__i18n = s.__i18n), a.__root = t, this === this.$root)
          this.$i18n = vn(e, a);
        else {
          a.__injectWithOption = !0, a.__extender = n.__vueI18nExtend, this.$i18n = kt(a);
          const o = this.$i18n;
          o.__extender && (o.__disposer = o.__extender(this.$i18n));
        }
      } else if (s.__i18n)
        if (this === this.$root)
          this.$i18n = vn(e, s);
        else {
          this.$i18n = kt({
            __i18n: s.__i18n,
            __injectWithOption: !0,
            __extender: n.__vueI18nExtend,
            __root: t
          });
          const a = this.$i18n;
          a.__extender && (a.__disposer = a.__extender(this.$i18n));
        }
      else
        this.$i18n = e;
      s.__i18nGlobal && Zn(t, s, s), this.$t = (...a) => this.$i18n.t(...a), this.$rt = (...a) => this.$i18n.rt(...a), this.$te = (a, o) => this.$i18n.te(a, o), this.$d = (...a) => this.$i18n.d(...a), this.$n = (...a) => this.$i18n.n(...a), this.$tm = (a) => this.$i18n.tm(a), n.__setInstance(r, this.$i18n);
    },
    mounted() {
      if (process.env.NODE_ENV !== "production" && this.$el && this.$i18n) {
        const r = this.$i18n;
        this.$el.__VUE_I18N__ = r.__composer;
        const s = this.__v_emitter = Vt();
        r.__enableEmitter && r.__enableEmitter(s), s.on("*", xe);
      }
    },
    unmounted() {
      const r = Ue();
      if (!r)
        throw z(G.UNEXPECTED_ERROR);
      const s = this.$i18n;
      process.env.NODE_ENV !== "production" && this.$el && this.$el.__VUE_I18N__ && (this.__v_emitter && (this.__v_emitter.off("*", xe), delete this.__v_emitter), this.$i18n && (s.__disableEmitter && s.__disableEmitter(), delete this.$el.__VUE_I18N__)), delete this.$t, delete this.$rt, delete this.$te, delete this.$d, delete this.$n, delete this.$tm, s.__disposer && (s.__disposer(), delete s.__disposer, delete s.__extender), n.__deleteInstance(r), delete this.$i18n;
    }
  };
}
function vn(e, t) {
  e.locale = t.locale || e.locale, e.fallbackLocale = t.fallbackLocale || e.fallbackLocale, e.missing = t.missing || e.missing, e.silentTranslationWarn = t.silentTranslationWarn || e.silentFallbackWarn, e.silentFallbackWarn = t.silentFallbackWarn || e.silentFallbackWarn, e.formatFallbackMessages = t.formatFallbackMessages || e.formatFallbackMessages, e.postTranslation = t.postTranslation || e.postTranslation, e.warnHtmlInMessage = t.warnHtmlInMessage || e.warnHtmlInMessage, e.escapeParameterHtml = t.escapeParameterHtml || e.escapeParameterHtml, e.sync = t.sync || e.sync, e.__composer[Jn](t.pluralizationRules || e.pluralizationRules);
  const n = Yt(e.locale, {
    messages: t.messages,
    __i18n: t.__i18n
  });
  return Object.keys(n).forEach((r) => e.mergeLocaleMessage(r, n[r])), t.datetimeFormats && Object.keys(t.datetimeFormats).forEach((r) => e.mergeDateTimeFormat(r, t.datetimeFormats[r])), t.numberFormats && Object.keys(t.numberFormats).forEach((r) => e.mergeNumberFormat(r, t.numberFormats[r])), e;
}
const jt = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Ua({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((r, s) => [
    ...r,
    // prettier-ignore
    ...s.type === kn ? s.children : [s]
  ], []) : t.reduce((n, r) => {
    const s = e[r];
    return s && (n[r] = s()), n;
  }, $());
}
function nr() {
  return kn;
}
const wa = /* @__PURE__ */ Ft({
  /* eslint-disable */
  name: "i18n-t",
  props: J({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      validator: (e) => j(e) || !isNaN(e)
    }
  }, jt),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const { slots: n, attrs: r } = t, s = e.i18n || Bt({
      useScope: e.scope,
      __useComponent: !0
    });
    return () => {
      const a = Object.keys(n).filter((L) => L !== "_"), o = $();
      e.locale && (o.locale = e.locale), e.plural !== void 0 && (o.plural = I(e.plural) ? +e.plural : e.plural);
      const c = Ua(t, a), u = s[St](e.keypath, c, o), E = J($(), r), O = I(e.tag) || F(e.tag) ? e.tag : nr();
      return Rn(O, E, u);
    };
  }
}), An = wa;
function Va(e) {
  return K(e) && !I(e[0]);
}
function rr(e, t, n, r) {
  const { slots: s, attrs: a } = t;
  return () => {
    const o = { part: !0 };
    let c = $();
    e.locale && (o.locale = e.locale), I(e.format) ? o.key = e.format : F(e.format) && (I(e.format.key) && (o.key = e.format.key), c = Object.keys(e.format).reduce((N, C) => n.includes(C) ? J($(), N, { [C]: e.format[C] }) : N, $()));
    const u = r(e.value, o, c);
    let E = [o.key];
    K(u) ? E = u.map((N, C) => {
      const P = s[N.type], A = P ? P({ [N.type]: N.value, index: C, parts: u }) : [N.value];
      return Va(A) && (A[0].key = `${N.type}-${C}`), A;
    }) : I(u) && (E = [u]);
    const O = J($(), a), L = I(e.tag) || F(e.tag) ? e.tag : nr();
    return Rn(L, O, E);
  };
}
const $a = /* @__PURE__ */ Ft({
  /* eslint-disable */
  name: "i18n-n",
  props: J({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, jt),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || Bt({
      useScope: e.scope,
      __useComponent: !0
    });
    return rr(e, t, Kn, (...r) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[Pt](...r)
    ));
  }
}), Cn = $a;
function Wa(e, t) {
  const n = e;
  if (e.mode === "composition")
    return n.__getInstance(t) || e.global;
  {
    const r = n.__getInstance(t);
    return r != null ? r.__composer : e.global.__composer;
  }
}
function Ga(e) {
  const t = (o) => {
    process.env.NODE_ENV !== "production" && wt(Ye(oe.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE));
    const { instance: c, value: u } = o;
    if (!c || !c.$)
      throw z(G.UNEXPECTED_ERROR);
    const E = Wa(e, c.$), O = Sn(u);
    return [
      Reflect.apply(E.t, E, [...Dn(O)]),
      E
    ];
  };
  return {
    created: (o, c) => {
      const [u, E] = t(c);
      se && e.global === E && (o.__i18nWatcher = ht(E.locale, () => {
        c.instance && c.instance.$forceUpdate();
      })), o.__composer = E, o.textContent = u;
    },
    unmounted: (o) => {
      se && o.__i18nWatcher && (o.__i18nWatcher(), o.__i18nWatcher = void 0, delete o.__i18nWatcher), o.__composer && (o.__composer = void 0, delete o.__composer);
    },
    beforeUpdate: (o, { value: c }) => {
      if (o.__composer) {
        const u = o.__composer, E = Sn(c);
        o.textContent = Reflect.apply(u.t, u, [
          ...Dn(E)
        ]);
      }
    },
    getSSRProps: (o) => {
      const [c] = t(o);
      return { textContent: c };
    }
  };
}
function Sn(e) {
  if (I(e))
    return { path: e };
  if (k(e)) {
    if (!("path" in e))
      throw z(G.REQUIRED_VALUE, "path");
    return e;
  } else
    throw z(G.INVALID_VALUE);
}
function Dn(e) {
  const { path: t, locale: n, args: r, choice: s, plural: a } = e, o = {}, c = r || {};
  return I(n) && (o.locale = n), j(s) && (o.plural = s), j(a) && (o.plural = a), [t, c, o];
}
function xa(e, t, ...n) {
  const r = k(n[0]) ? n[0] : {};
  (M(r.globalInstall) ? r.globalInstall : !0) && ([An.name, "I18nT"].forEach((a) => e.component(a, An)), [Cn.name, "I18nN"].forEach((a) => e.component(a, Cn)), [yn.name, "I18nD"].forEach((a) => e.component(a, yn))), e.directive("t", Ga(t));
}
const Ya = /* @__PURE__ */ le("global-vue-i18n");
function to(e = {}) {
  const t = __VUE_I18N_LEGACY_API__ && M(e.legacy) ? e.legacy : __VUE_I18N_LEGACY_API__;
  process.env.NODE_ENV !== "production" && t && wt(Ye(oe.DEPRECATE_LEGACY_MODE));
  const n = M(e.globalInjection) ? e.globalInjection : !0, r = /* @__PURE__ */ new Map(), [s, a] = Ha(e, t), o = /* @__PURE__ */ le(process.env.NODE_ENV !== "production" ? "vue-i18n" : "");
  function c(L) {
    return r.get(L) || null;
  }
  function u(L, N) {
    r.set(L, N);
  }
  function E(L) {
    r.delete(L);
  }
  const O = {
    // mode
    get mode() {
      return __VUE_I18N_LEGACY_API__ && t ? "legacy" : "composition";
    },
    // install plugin
    async install(L, ...N) {
      if (process.env.NODE_ENV !== "production" && (L.__VUE_I18N__ = O), L.__VUE_I18N_SYMBOL__ = o, L.provide(L.__VUE_I18N_SYMBOL__, O), k(N[0])) {
        const A = N[0];
        O.__composerExtend = A.__composerExtend, O.__vueI18nExtend = A.__vueI18nExtend;
      }
      let C = null;
      !t && n && (C = Za(L, O.global)), __VUE_I18N_FULL_INSTALL__ && xa(L, O, ...N), __VUE_I18N_LEGACY_API__ && t && L.mixin(Ma(a, a.__composer, O));
      const P = L.unmount;
      if (L.unmount = () => {
        C && C(), O.dispose(), P();
      }, process.env.NODE_ENV !== "production") {
        if (!await ba(L, O))
          throw z(G.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
        const S = Vt();
        if (t) {
          const f = a;
          f.__enableEmitter && f.__enableEmitter(S);
        } else {
          const f = a;
          f[Oe] && f[Oe](S);
        }
        S.on("*", xe);
      }
    },
    // global accessor
    get global() {
      return a;
    },
    dispose() {
      s.stop();
    },
    // @internal
    __instances: r,
    // @internal
    __getInstance: c,
    // @internal
    __setInstance: u,
    // @internal
    __deleteInstance: E
  };
  return O;
}
function Bt(e = {}) {
  const t = Ue();
  if (t == null)
    throw z(G.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw z(G.NOT_INSTALLED);
  const n = Ka(t), r = Ba(n), s = qn(t), a = ja(e, s);
  if (a === "global")
    return Zn(r, e, s), r;
  if (a === "parent") {
    let u = Xa(n, t, e.__useComponent);
    return u == null && (process.env.NODE_ENV !== "production" && me(Ye(oe.NOT_FOUND_PARENT_SCOPE)), u = r), u;
  }
  const o = n;
  let c = o.__getInstance(t);
  if (c == null) {
    const u = J({}, e);
    "__i18n" in s && (u.__i18n = s.__i18n), r && (u.__root = r), c = Ht(u), o.__composerExtend && (c[yt] = o.__composerExtend(c)), Qa(o, t, c), o.__setInstance(t, c);
  }
  return c;
}
function Ha(e, t) {
  const n = ur(), r = __VUE_I18N_LEGACY_API__ && t ? n.run(() => kt(e)) : n.run(() => Ht(e));
  if (r == null)
    throw z(G.UNEXPECTED_ERROR);
  return [n, r];
}
function Ka(e) {
  const t = ar(e.isCE ? Ya : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw z(e.isCE ? G.NOT_INSTALLED_WITH_PROVIDE : G.UNEXPECTED_ERROR);
  return t;
}
function ja(e, t) {
  return Ze(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Ba(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function Xa(e, t, n = !1) {
  let r = null;
  const s = t.root;
  let a = Ja(t, n);
  for (; a != null; ) {
    const o = e;
    if (e.mode === "composition")
      r = o.__getInstance(a);
    else if (__VUE_I18N_LEGACY_API__) {
      const c = o.__getInstance(a);
      c != null && (r = c.__composer, n && r && !r[Qn] && (r = null));
    }
    if (r != null || s === a)
      break;
    a = a.parent;
  }
  return r;
}
function Ja(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Qa(e, t, n) {
  let r = null;
  ir(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, r = Vt();
      const s = n;
      s[Oe] && s[Oe](r), r.on("*", xe);
    }
  }, t), cr(() => {
    const s = n;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (r && r.off("*", xe), s[We] && s[We](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const a = s[yt];
    a && (a(), delete s[yt]);
  }, t);
}
const qa = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], Pn = ["t", "rt", "d", "n", "tm", "te"];
function Za(e, t) {
  const n = /* @__PURE__ */ Object.create(null);
  return qa.forEach((s) => {
    const a = Object.getOwnPropertyDescriptor(t, s);
    if (!a)
      throw z(G.UNEXPECTED_ERROR);
    const o = fr(a.value) ? {
      get() {
        return a.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(c) {
        a.value.value = c;
      }
    } : {
      get() {
        return a.get && a.get();
      }
    };
    Object.defineProperty(n, s, o);
  }), e.config.globalProperties.$i18n = n, Pn.forEach((s) => {
    const a = Object.getOwnPropertyDescriptor(t, s);
    if (!a || !a.value)
      throw z(G.UNEXPECTED_ERROR);
    Object.defineProperty(e.config.globalProperties, `$${s}`, a);
  }), () => {
    delete e.config.globalProperties.$i18n, Pn.forEach((s) => {
      delete e.config.globalProperties[`$${s}`];
    });
  };
}
const za = /* @__PURE__ */ Ft({
  /* eslint-disable */
  name: "i18n-d",
  props: J({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, jt),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || Bt({
      useScope: e.scope,
      __useComponent: !0
    });
    return rr(e, t, Hn, (...r) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[Dt](...r)
    ));
  }
}), yn = za;
ga();
Ws(Ns);
Gs(Ms);
xs(Mn);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Te();
  e.__INTLIFY__ = !0, Ts(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
export {
  to as c,
  Bt as u
};
